export const Ease = {
    Smooth: "cubic-bezier(.56,.15,.16,1)",
    LateSnap: "cubic-bezier(.73,0,.39,.99)",
    EarlySnap: "cubic-bezier(.12,0,.32,.89)",
    Bounce: "cubic-bezier(.12,0,.57,1.13)"
};